/**
 *  @class
 *  @function StoreBlog-blog-post
 */
document.getElementsByName("store-category-radio").forEach(
  r => r.addEventListener("change",
    e => {
      /*       console.log("change:" + e.target.value);       */
      const sel_category = e.target.value;
      console.log(sel_category);
      const store_article_all = document.getElementsByClassName('StoreBlog-category');

      for (let i = 0; i < store_article_all.length; i++) {
        const article = store_article_all[i];
        const data_blogtag = $('.StoreBlog-category');
        const blog_tag_array = data_blogtag[i].dataset.tag.split(",")
        console.log(blog_tag_array);
        /*         console.log(article);
                console.log(article.classList.contains(sel_category));
                console.log(article.data('blogtag')); */
        if (sel_category != "all") {
          if (blog_tag_array.includes(sel_category) == true) {
            article.style.display = "block";
          } else {
            article.style.display = "none";
          }
        } else {
          article.classList.remove('sel_StoreBlog_category');
          article.style.display = "block";
        };
      }
    }
  )
);